import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "foam-roofs-over-your-garage-the-ultimate-insulation-solution";
export const Route = createFileRoute("/foam-roofs-over-your-garage-the-ultimate-insulation-solution")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
